import { Link } from 'react-router-dom';
import PageTransition from '../components/PageTransition';
import { useBlog } from '../context/BlogContext';
import { useAuth } from '../context/AuthContext';
import SubscribeBox from '../components/SubscribeBox';
import { motion } from 'framer-motion';
import { hasRichContent } from '../utils/richContent';

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 15 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, delay, ease: [0.4, 0, 0.2, 1] },
});

export default function AboutUs() {
  const { siteSettings, settingsLoading } = useBlog();
  const { user } = useAuth();
  const aboutHtml = siteSettings?.aboutContent || '';
  const hasContent = hasRichContent(aboutHtml);

  const firstImageMatch = aboutHtml.match(/<img\b[^>]*>/i);
  const firstImageHtml = firstImageMatch ? firstImageMatch[0] : '';
  const aboutTextHtml = firstImageMatch
    ? aboutHtml
      .replace(firstImageHtml, '')
      .replace(/<p>\s*(?:&nbsp;|<br\s*\/?>|\s)*<\/p>/gi, '')
      .trim()
    : aboutHtml;
  const hasSplitIntro = hasRichContent(aboutTextHtml) && !!firstImageHtml;

  return (
    <PageTransition>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '3rem 2rem 5rem' }}>
        {!settingsLoading && (hasContent ? (
          <motion.div {...fade(0.2)} className={`rich-content about-rich-content${hasSplitIntro ? ' about-split' : ''}`}>
            {hasSplitIntro ? (
              <>
                <div className="about-split-text" dangerouslySetInnerHTML={{ __html: aboutTextHtml }} />
                <div className="about-split-image" dangerouslySetInnerHTML={{ __html: firstImageHtml }} />
              </>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: aboutHtml }} />
            )}
          </motion.div>
        ) : (
          <>
            <motion.div {...fade(0.1)} style={{ marginBottom: '2.5rem' }}>
              <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: 'clamp(2rem, 5vw, 2.5rem)', lineHeight: 1.2, fontWeight: 400, textAlign: 'center' }}>
                About Us
              </h1>
            </motion.div>

            <motion.div {...fade(0.2)} style={{ textAlign: 'center', padding: '3rem 1rem' }}>
              <p style={{ color: 'var(--text-tertiary)', fontSize: '1rem', lineHeight: 1.7, marginBottom: '1.5rem' }}>
                This page hasn't been written yet.
              </p>
              {user?.role === 'admin' && (
                <Link to="/admin" className="btn btn-primary" style={{ fontSize: '0.85rem' }}>
                  Add content in Dashboard
                </Link>
              )}
              <div style={{ marginTop: '2rem' }}>
                <Link to="/philosophy" style={{ color: 'var(--accent-warm)', fontSize: '0.9rem' }}>
                  Read our philosophy ->
                </Link>
              </div>
            </motion.div>
          </>
        ))}

        <SubscribeBox />
      </div>
    </PageTransition>
  );
}
